// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css } from '@emotion/react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var listContainerStyles = css({
  width: '100%',
  paddingTop: 0,
  minHeight: '80px',
  marginTop: "var(--ds-space-200, 16px)",
  marginBottom: "var(--ds-space-200, 16px)",
  flexGrow: 1,
  display: 'flex',
  flexDirection: 'column'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var spinnerContainerStyles = css({
  flexGrow: 1,
  flexDirection: 'column',
  alignItems: 'center'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var listStyles = css({
  padding: "var(--ds-space-0, 0px)",
  marginTop: "var(--ds-space-0, 0px)",
  marginBottom: "var(--ds-space-0, 0px)",
  marginLeft: 'calc(-1 * var(--link-picker-padding-left))',
  marginRight: 'calc(-1 * var(--link-picker-padding-right))',
  listStyle: 'none'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
export var listTitleStyles = css({
  font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
  fontWeight: "var(--ds-font-weight-bold, 700)",
  color: "var(--ds-text-subtlest, #626F86)",
  marginBottom: "var(--ds-space-050, 4px)"
});